module.exports = __webpack_public_path__ + "img/jiankong1.0f5c3f2a.png";